import { SectionLabel } from '@/components/marketing/v2/SectionLabel';

const BEFORE: ReadonlyArray<string> = [
  '« Mon logiciel se bloque dès que le réseau coupe — et il coupe tous les jours entre 14h et 16h. »',
  '« Pour accepter Orange Money, il faut taper le montant dans 3 applis différentes et recopier. »',
  '« Je ne vois jamais mes vraies marges. Mon cahier et ma calculatrice ne parlent pas. »',
  '« Le support ne parle pas français. Ou alors il me rappelle à 2h du matin, heure de Dakar. »',
  "« L'abonnement coûte plus cher que mon loyer. Je suis abandonné la 2ᵉ année. »",
];

const AFTER: ReadonlyArray<string> = [
  'Offline-first : la caisse tourne à 100% sans réseau, la synchro se fait après.',
  'Orange, MTN, Wave intégrés dans le même ticket — paiement mixte possible.',
  'Marges, rotation, top produit : un seul tableau de bord, tous les chiffres liés.',
  'Support 100% français, équipe francophone, fuseaux africains.',
  'Plan gratuit permanent, payant à partir de 333 F / jour. Annulable en 1 clic.',
];

export default function BeforeAfterAboutV2() {
  return (
    <section className="bg-paper py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <SectionLabel className="justify-center">Pourquoi Velko</SectionLabel>
          <h2 className="mt-6 font-marketing-display text-[clamp(36px,5vw,64px)] font-bold leading-[1] tracking-[-0.035em] text-charcoal-800">
            Avant. <span className="underline-lime">Après.</span>
          </h2>
          <p className="mt-6 font-marketing-body text-lg text-charcoal-600">
            On a écouté les commerçants sur le terrain avant d'écrire la première ligne de code.
            Voici ce qu'on a entendu — et ce qu'on a construit en réponse.
          </p>
        </div>

        <div className="mt-16 grid gap-8 md:grid-cols-2">
          <article className="relative border-2 border-charcoal-800 bg-paper p-8 shadow-neobrutal-6 md:p-10">
            <div className="absolute -top-4 left-6 inline-flex items-center gap-2 border-2 border-charcoal-800 bg-white px-3 py-1 font-marketing-mono text-[11px] font-bold uppercase tracking-[0.12em] text-charcoal-600 shadow-neobrutal-2">
              La réalité terrain
            </div>
            <h3 className="mt-4 font-marketing-display text-[26px] font-bold leading-[1.1] tracking-[-0.02em] text-charcoal-800 md:text-[32px]">
              Ce qu'on entend
              <br />
              sur le terrain
            </h3>
            <ul className="mt-8 space-y-4">
              {BEFORE.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center border-2 border-charcoal-800 bg-white text-terracotta-500">
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                    >
                      <path d="M3 3l6 6" />
                      <path d="M9 3l-6 6" />
                    </svg>
                  </span>
                  <span className="font-marketing-body text-[15px] italic leading-relaxed text-charcoal-700">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </article>

          <article className="relative border-[3px] border-lime-600 bg-lime-500/10 p-8 shadow-neobrutal-10 md:p-10">
            <div className="absolute -top-4 left-6 inline-flex items-center gap-2 border-2 border-charcoal-800 bg-lime-500 px-3 py-1 font-marketing-mono text-[11px] font-bold uppercase tracking-[0.12em] text-charcoal-800 shadow-neobrutal-2">
              Ce qu'on a construit
            </div>
            <h3 className="mt-4 font-marketing-display text-[26px] font-bold leading-[1.1] tracking-[-0.02em] text-charcoal-800 md:text-[32px]">
              Les 5 choix radicaux
              <br />
              de Velko
            </h3>
            <ul className="mt-8 space-y-4">
              {AFTER.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center border-2 border-charcoal-800 bg-white text-lime-600">
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.8"
                    >
                      <path d="M2.5 6l2.5 2.5 5-5" />
                    </svg>
                  </span>
                  <span className="font-marketing-body text-[15px] font-medium leading-relaxed text-charcoal-800">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </article>
        </div>
      </div>
    </section>
  );
}
